import { arrayOf, shape, number, string } from 'prop-types'

import businessType from './businessType'
import cashflowDatumType from './cashflowDatumType'
import fiscalYearType from './fiscalYearType'
import selectorOptionType from './selectorOptionType'

export default shape({
  business:                  businessType,
  cashflowData:              arrayOf(cashflowDatumType),
  creditDataUrls:            arrayOf(string),
  creditScore:               number,
  filingStatus:              string,
  fiscalYears:               arrayOf(fiscalYearType),
  jointAccountAmount:        number,
  name:                      string,
  interimYears:              arrayOf(number),
  reportedRealEstatePayment: number,
  rid:                       number,
  scheduledMonthlyPayment:   number,
  spouseId:                  number,
  taxReturnUrls:             arrayOf(selectorOptionType)
})
